import { EllipsisVertical, Loader2, Unplug } from 'lucide-react';
import { ReactNode, useState } from 'react';
import { Button } from '../../../design-system/button/button';
import { Inline } from '../../../design-system/inline/inline';
import { Popover } from '../../../design-system/popover/popover';

type AccountActionDropdownMenuItemProps = {
  icon: ReactNode;
  label: string;
  onClick: () => void;
};

const AccountActionDropdownMenuItem = ({ icon, label, onClick }: AccountActionDropdownMenuItemProps) => {
  return (
    <Button
      variant="ghost"
      size="none"
      onClick={onClick}
      className={'rounded-xl px-4 py-[12px] hover:bg-seapoint-gray-medium focus-visible:ring-0'}
    >
      <Inline space={4} justify="start">
        <div className="h-4 w-4">{icon}</div>
        <span className={'text-sm font-normal text-black'}>{label}</span>
      </Inline>
    </Button>
  );
};

type AccountOptionsButtonProps = {
  onDisconnectAccount: () => Promise<void>;
};

export const AccountOptionsButton = ({ onDisconnectAccount }: AccountOptionsButtonProps) => {
  const [isLoading, setIsLoading] = useState(false);
  async function handleDisconnectAccount() {
    setIsLoading(true);
    await onDisconnectAccount().finally(() => setIsLoading(false));
  }
  return (
    <Popover
      className="min-w-12"
      side="bottom"
      align="end"
      triggerElement={
        <Button variant="ghost" className="flex h-8 w-8 justify-self-end" aria-label="Account options">
          {isLoading ? <Loader2 className="h-4 w-4 flex-shrink-0 animate-spin" /> : <EllipsisVertical size={16} />}
        </Button>
      }
      content={
        // TODO: Once we have the generic action menu component, refactor this to use it
        <AccountActionDropdownMenuItem
          icon={<Unplug size={16} className="text-seapoint-gray" />}
          label="Disconnect account"
          onClick={handleDisconnectAccount}
        />
      }
    />
  );
};
